import { Button } from '@thanx/uikit/button'
import { buildTranslate } from 'locales'
import CmsPage from 'scenes/Cms/components/CmsPage'
import ReplySection from './ReplySection'
import useEmailReplyRoutingForm from './useEmailReplyRoutingForm'

const t = buildTranslate('cms.settings.email_reply_routing')

/**
 * Self-serve page (OPE-519) where a merchant sets where replies to their
 * marketing and order/receipt emails are delivered. Each section is a radio:
 * "Do not accept replies" (blank = the no-reply default) or "Send replies to an
 * email address" (a non-thanx.com address). The page + nav entry are gated by
 * the shared `/settings` CMS permission route. Form state + persistence live in
 * useEmailReplyRoutingForm; sections render via the presentational ReplySection.
 */
function EmailReplyRouting({ showTitle = true }: { showTitle?: boolean }) {
  const form = useEmailReplyRoutingForm()

  // GET failed — render the page shell with an error message instead of an
  // empty form that would silently save over the merchant's real values.
  if (form.isError) {
    return (
      <CmsPage showTitle={showTitle} title={t('title')}>
        <p className="grey-70" role="alert">
          {t('load_error')}
        </p>
      </CmsPage>
    )
  }

  return (
    <CmsPage
      showTitle={showTitle}
      title={t('title')}
      description={t('description')}
      isLoading={!form.ready}
    >
      <ReplySection
        title={t('marketing_label')}
        idPrefix="marketing"
        state={form.marketing.state}
        onModeChange={form.marketing.onModeChange}
        onAddressChange={form.marketing.onAddressChange}
        onAddressBlur={form.marketing.onAddressBlur}
        error={form.marketing.error}
      />
      <ReplySection
        title={t('transactional_label')}
        idPrefix="transactional"
        state={form.transactional.state}
        onModeChange={form.transactional.onModeChange}
        onAddressChange={form.transactional.onAddressChange}
        onAddressBlur={form.transactional.onAddressBlur}
        error={form.transactional.error}
      />
      <Button type="button" onClick={form.save} disabled={form.isSaving}>
        {t('save_button')}
      </Button>
    </CmsPage>
  )
}

export default EmailReplyRouting
